import $ from 'jquery';

const hideModal = (modalId) => {
  $('#createCollectionModal').modal('hide');
  $('#createPlaylistModal').modal('hide');
  $('#removeModal').modal('hide');
  $('#deleteModal').modal('hide');
  $('#editCollectionModal').modal('hide');
  $('#editPlaylistModal').modal('hide');
  $('#editAccountModal').modal('hide');
  $('#leaveOrganisationModal').modal('hide');
  $('#onboardingQuestionsModal').modal('hide');
  $('#wonder-information-modal').modal('hide');
  $('#wonder-list-modal').modal('hide');
  $('#wonder-activities-modal').modal('hide');
  $('#wonder-settings-modal').modal('hide');
  if (modalId) {
    $(`#${modalId}`).modal('hide');
  }
};

export const showModal = (modalId, disableClose = false, timeOut = 500) => {
  const isMobile = window.innerWidth < 768;
  const closeOptions = disableClose
    ? {
        keyboard: false,
        backdrop: isMobile ? false : 'static',
      }
    : {
        backdrop: !isMobile,
      };

  setTimeout(() => {
    $(`#${modalId}`).modal({
      show: true,
      ...closeOptions,
    });
  }, timeOut);
};

export default hideModal;
